import { useEffect, useMemo, useState } from "react";
import { brands as fallbackBrands } from "../data/brands";
import api from "../lib/api";
import "./Brands.css";

export default function Brands() {
  const [activeCategory, setActiveCategory] = useState("All");
  const [brandItems, setBrandItems] = useState(fallbackBrands);

  useEffect(() => {
    api.get("/brands").then((response) => {
      if (Array.isArray(response.data) && response.data.length > 0) setBrandItems(response.data);
    }).catch(() => {});
  }, []);

  const categories = [
    "All",
    "Cooking",
    "Refrigeration-line",
    "Coffee & Bar",
    "Bakery",
    "Food Processing",
    "Snack Maker",
    "Dish Washer",
    "Super Market",
    "Dry Store",
  ];

  const filteredBrands = useMemo(() => {
  if (activeCategory === "All") return brandItems;

  return brandItems.filter(
    (brand) =>
      brand.categories &&
      brand.categories.includes(activeCategory)
  );
  }, [activeCategory, brandItems]);

  return (
    <div className="brands-page">

      <div className="brands-container">

        {/* Category Buttons */}

        <div className="brands-filter">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`filter-btn ${
  activeCategory === category ? "active" : ""
}`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Brand Grid */}

        <div className="brands-grid">

          {filteredBrands.map((brand) => (
            <a
              key={brand.slug}
              href={`https://uae.mariotstore.com/en/shop?brand=${brand.slug}`}
              target="_blank"
              rel="noopener noreferrer"
              className="brand-card"
            >
              <div className="brand-image">
                <img
                  src={brand.image || brand.logo}
                  alt={brand.name}
                  loading="lazy"
                />
              </div>
            </a>
          ))}

        </div>

      </div>

    </div>
  );
}
